export class VerifiCard {
     accum:number;
     b:any;
     bytflag:any;
     poly = 0xA001;

    public verificar(s: string, pin: any) {
        if(this.crc16pin(s) == pin){
            return true;
        }else{
            return false;
        }
    }

    private crc16(s:string) {
        //debugger;
        this.accum = 0;
        for (let i = 0; i < s.length; i++) {
            this.b = s.charCodeAt(i);
            this.accum = this.accum ^ this.b;
            
            for (let j = 0; j <= 7; j++) {
                this.bytflag = this.accum & 1;
                this.accum = this.accum / 2;
                if (this.bytflag){
                    this.accum = this.accum ^ this.poly;
                }
                this.accum = this.accum & 0xFFFF;
            }
        }
        return this.accum.toString(16);
      }
      
      private crc16pin(s){
        s = this.crc16(s);
        s = parseInt(s, 16);
        if ((s & 0x8000) > 0) {
            s = s - 0x10000;
        }
        s = Math.abs(s)%1000;
      
        return s.toString().padStart(3, "0");
      }
}